import { helpers } from "vuelidate/lib/validators";

const phoneNumberRegex = /^((\+\d{12,})|(\d{11}))$/;

const phoneNumber = (value) =>
  !helpers.req(value) ||
  (value && phoneNumberRegex.test(value.replace(/\s/g, "")));

export default phoneNumber;
